import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.legalDocumentsSlice || initialState;

export const selectLegalDocumentsSlice = createSelector(
  [selectSlice],
  state => state,
);
